











import { Component, Prop, Vue } from 'vue-property-decorator';
import Unavailability from '@/models/unavailability/unavailability';
import Nullable from '@/types/nullable';

@Component({})
export default class UnavailabilityDay extends Vue {
  @Prop({ type: Object, default: null }) public unavailability!: Nullable<Unavailability>;

  click(e: any){
    this.$emit('click', e);
  }
}
